module.exports = __webpack_public_path__ + "e61254a9ea4e15252759b54693587dd3.png";